import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import { getRoleIdType } from '../../auth/selectors';
import { validateBarberSale, validateShopSale } from '../validated/actions';

const validate = (props, order) => {
  const action = (props.shopOrBarber.type === 'barber') ? validateBarberSale : validateShopSale;
  return action(props.shopOrBarber.id, order);
};

const withValidateSaleAction = compose(
  connect(
    state => ({
      shopOrBarber: getRoleIdType(state),
    }),
  ),
  withHandlers({
    validateSaleAction: props => order => validate(props, order),
  }),
);

export default withValidateSaleAction;
